class SiteBenefits extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.grid = this.querySelector('.site-benefits__grid');
    this.dots = [...this.querySelectorAll('.site-benefits__dot')];
    if (!this.grid || this.dots.length === 0) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.grid.addEventListener('scroll', () => this.updateActiveDot(), { passive: true, signal });
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.scrollToItem(Number(dot.dataset.index)), { signal });
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    delete this.dataset.initialized;
  }

  updateActiveDot() {
    if (this.grid.clientWidth === 0) return;
    const index = Math.min(this.dots.length - 1, Math.max(0, Math.round(this.grid.scrollLeft / this.grid.clientWidth)));
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  scrollToItem(index) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.grid.scrollTo({ left: this.grid.clientWidth * index, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('site-benefits')) customElements.define('site-benefits', SiteBenefits);
